/* Laadt en start productkaart-video's pas zodra ze (bijna) in beeld komen. */
(function () {
  function start(video) {
    var bron = video.querySelector('source[data-src]');
    if (bron && !bron.getAttribute('src')) {
      bron.setAttribute('src', bron.getAttribute('data-src'));
      video.load();
    }
    var speel = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    if (video.readyState >= 2) speel();
    else video.addEventListener('canplay', speel, { once: true });
  }

  function init() {
    var videos = document.querySelectorAll('video[data-f4k-lazyvideo]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(start);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          start(e.target);
        });
      },
      { rootMargin: '200px' }
    );
    videos.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
